// extracted by mini-css-extract-plugin
export var bold = "Heading-module--bold--06099";
export var center = "Heading-module--center--18df3";
export var marginBottomL = "Heading-module--marginBottomL--d4a5f";
export var marginBottomM = "Heading-module--marginBottomM--1e2b7";
export var marginBottomS = "Heading-module--marginBottomS--a3a28";
export var marginBottomXs = "Heading-module--marginBottomXs--7b7cf";
export var marginBottomXxs = "Heading-module--marginBottomXxs--4d91a";
export var sizeL = "Heading-module--sizeL--4de45";
export var sizeM = "Heading-module--sizeM--56a80";
export var sizeSL = "Heading-module--sizeSL--103eb";
export var sizeSM = "Heading-module--sizeSM--99247";